import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";
import AfterAchievementAchievedEvent from "@/modules/archiements/events/AfterAchievementAchievedEvent";
import AchievementActionScreen from "@/modules/archiements/components/AchievementActionScreen.vue";
import AfterGameLoadedEvent from "@/modules/main-menu/events/AfterGameLoadedEvent";

@injectable()
export class AchievementActionScreenEventSubscriber implements EventSubscriber {
  private loaded = false;

  constructor(
    @inject(ActionScreener) private actionScreener: ActionScreener,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterGameLoadedEvent, callback: this.onAfterGameLoadedEvent},
      {event: AfterAchievementAchievedEvent, callback: this.onAfterAchievementAchievedEvent},
    ];
  }

  async onAfterGameLoadedEvent(event: AfterGameLoadedEvent): Promise<void> {
    this.loaded = true;
  }

  async onAfterAchievementAchievedEvent(event: AfterAchievementAchievedEvent): Promise<void> {
    if (!this.loaded) {
      return;
    }

    await this.actionScreener.show({
      component: AchievementActionScreen,
      props: {achievement: event.achievement},
    });
  }
}